import { DateUtils } from '../utils/date.utils';
import { PortCallModel } from './port-call.model';
import { VesselModel } from './vessel.model';

export class VoyageSummaryModel {
  //Mode details objs
  public vesselDetails?: VesselModel;
  public portCalls: PortCallModel[] = [];

  constructor(
    public id?: any,
    public voyageNumber?: string,
    public vessel?: string,
    public status?: string
  ) { }

  public fromJSON(json: any): VoyageSummaryModel {
    if (json) {
      this.id = json.id;
      this.voyageNumber = json.voyageNumber;
      this.status = json.status;
      this.portCalls = [];

      //Check vessel
      if (typeof json.vessel === 'object') {
        this.vesselDetails = new VesselModel().fromJSON(json.vessel);
        this.vessel = this.vesselDetails.id?.toString();
      } else {
        this.vesselDetails = undefined;
        this.vessel = json.vessel;
      }

      //Check port calls
      if (Array.isArray(json.portCalls)) {
        this.portCalls = json.portCalls.map((portCall: any) =>
          new PortCallModel().fromJSON(portCall)
        );
      }
    }
    return this;
  }

  public fromJSONList(json: any): VoyageSummaryModel[] {
    if (json) {
      return json.map((element: any) =>
        new VoyageSummaryModel().fromJSON(element)
      );
    }
    return [];
  }

  public toJSON() {
    const normalizedVoyageNumber = this.voyageNumber?.trim();

    return {
      id: this.id,
      ...(normalizedVoyageNumber ? { voyageNumber: normalizedVoyageNumber } : {}),
      vessel: this.vessel,
      status: this.status,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.voyageNumber ?? '';
  }
}
